"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
var _constants = require("../../../../utils/constants");
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BroadbandValueText = _styledComponents.default.span`
  font-weight: bold;
  margin-right: 5px;
`;
const BroadbandCardInfo = _ref => {
  let {
    broadband,
    isAdditionalBroadband
  } = _ref;
  const characteristics = broadband.selectedVariant.characteristics;
  const parseSpecValue = spec => {
    const specValues = spec.value.map(val => {
      return val.value >= _constants.UNLIMITED_VALUE ? _services.locale.localeString('Recommendation.BroadbandUnlimited') : val.value;
    });
    const isAllBooleans = specValues.every(val => typeof val === 'boolean');
    return isAllBooleans ? specValues.every(Boolean) : specValues.join(', ');
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, characteristics.map((spec, index) => {
    const valueText = parseSpecValue(spec);
    if (!valueText) return null;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      layout: {
        sm: [2, 10],
        md: isAdditionalBroadband ? [2, 10] : [1, 11]
      },
      spacing: 1,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      name: spec.iconName,
      size: isAdditionalBroadband ? 3 : 4
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, /*#__PURE__*/_react.default.createElement(BroadbandValueText, null, valueText, " ", spec.id === 'DATA_NATIONAL' && spec.valueType), _services.locale.localeString(`Specs.${spec.name}`))), index < characteristics.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  }));
};
var _default = BroadbandCardInfo;
exports.default = _default;